import { EventRegistrationSideEffect } from "../Common/types";
import { usePromisedRequest } from "../Common/request";
import { resolveNoContent } from "./Utils/utils";

export type EventRegistrationAutoFixScope = {
    eventId: number;
    sideEffects: EventRegistrationSideEffect[];
};

export default {
    fixEventRegistrationSideEffects(eventId: number, scope: EventRegistrationAutoFixScope): Promise<void> {
        return usePromisedRequest({
            url: `/api/events/${eventId}/auto-fix/event-registrations`,
            method: "post",
            json: scope,
        }).then(resolveNoContent());
    },
};
